import messages from './loading-bar_msg.json';

(function () {
 
    window.addEventListener('DOMContentLoaded', (e) => {

        if (document.getElementById('ProductType') == null) return;
        const productType = (document.getElementById('ProductType') as HTMLInputElement).value;
        const originOfData = (document.getElementById('OriginOfData') as HTMLInputElement).value;

        const round = (value, precision) => {
            var multiplier = Math.pow(10, precision || 0);
            return Math.round(value * multiplier) / multiplier;
        }

        const productRelatedConfiguration = messages[productType] || messages['Default'];
        const processRelatedConfiguration = productRelatedConfiguration[originOfData] || productRelatedConfiguration['Default'];

        const animationDuration = (processRelatedConfiguration.ProcessingDuration * 1000);
        const animationUpdate = 50;
        const setElemStyle = (elem, prop, val) => {
            const rval = round(val, 2);
            elem.style.setProperty(`--${prop}`, rval);
        }
        const setMessage = (elem, time) => {
            let setIndex = Math.floor((time / animationDuration) * processRelatedConfiguration.Messages.length);
            const textElement = elem.querySelector('p');
    
            if (time >= animationDuration) {
                textElement.innerText = 'Nog even geduld. Het scherm wordt vernieuwd zodra de gegevens zijn verwerkt';
            } else {
                textElement.innerText = processRelatedConfiguration.Messages[setIndex];
            }
        }
        const loadingBars = Array.from(document.querySelectorAll('.c-loading-bar'));

        if (loadingBars['length']) {
            for (let loadingBar of loadingBars) {
                let currentTime = 0;
                const animInterval = setInterval(() => {
                    if (currentTime <= animationDuration) {
                        const currentPercent = 100 / (animationDuration / currentTime);
                        setElemStyle(loadingBar, 'progress', currentPercent);
                        setMessage(loadingBar, currentTime);
                        currentTime = currentTime + animationUpdate;
                    }
                    else {
                        clearInterval(animInterval);
                        setMessage(loadingBar, animationDuration);
                        setElemStyle(loadingBar, 'progress', 100);
                    }
                }, animationUpdate);
            }
        }
    })
}());